import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { getUserId } from 'lib/utils/authentication';

const clientSideID = process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_KEY ?? '';

const getContext = () => {
  const userID = getUserId();
  return {
    kind: 'user',
    anonymous: userID === '',
    key: userID ?? null,
  };
};

export const LDProvider = withLDProvider({
  options: {
    bootstrap: 'localStorage',
  },
  reactOptions: {
    useCamelCaseFlagKeys: false,
  },
  clientSideID,
  context: getContext(),
})(({ children }) => <>{children}</>);
